<template>
  <el-form
    ref="categoryForm"
    :model="internalCategory"
    label-width="160px"
    :rules="rules">

    <el-form-item :label="$t('report_categories.name')" prop="title">
      <el-input v-model="internalCategory.title"></el-input>
    </el-form-item>

    <el-form-item :label="$t('report_categories.type')" prop="type">
      <el-select v-model="internalCategory.type" style="width: 100%">
        <el-option
          v-for="type in categoryTypes"
          :key="type"
          :label="type"
          :value="type">
        </el-option>
      </el-select>
    </el-form-item>

    <el-form-item :label="$t('report_categories.level')" prop="level">
      <el-select v-model="internalCategory.level" style="width: 100%">
        <el-option
          v-for="level in categoryLevels"
          :key="level"
          :label="level"
          :value="level">
        </el-option>
      </el-select>
    </el-form-item>

    <el-form-item :label="$t('report_categories.color')" prop="color">
      <el-color-picker v-model="internalCategory.color" @change="updateColorCSS"></el-color-picker>
      <el-input v-model="internalCategory.color" style="width: calc(100% - 50px); margin-left: 10px"></el-input>
    </el-form-item>

    <el-form-item :label="$t('report_categories.priority')" prop="priority">
      <el-input-number v-model="internalCategory.priority" :min="0" :max="100"></el-input-number>
    </el-form-item>

    <el-form-item :label="$t('report_categories.visibility_duration')" prop="visibilityDurationInMillis">
      <el-input-number
        v-model="durationHours"
        :min="0"
        :max="720"
        @change="updateDurationMillis">
      </el-input-number>
      <span style="margin-left: 10px">{{ $t('report_categories.hours') }}</span>
    </el-form-item>

    <!-- Tenant selector for super admins -->
    <el-form-item
      v-if="isSuperAdmin"
      :label="$t('report_categories.tenant')"
      prop="tenantId">
      <el-select
        v-model="internalCategory.tenantId"
        filterable
        style="width: 100%"
        :placeholder="$t('report_categories.select_tenant')">
        <el-option
          v-for="tenant in tenants"
          :key="tenant.id"
          :label="tenant.name"
          :value="tenant.id">
        </el-option>
      </el-select>
    </el-form-item>

    <el-form-item>
      <el-button type="primary" @click="submitForm">{{ $t('base.save') }}</el-button>
      <el-button @click="$emit('cancel')">{{ $t('base.cancel') }}</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
import { ReportCategoryType, ReportCategoryLevel } from '@/model/ReportCategory';

export default {
  name: 'ReportCategoryForm',
  props: {
    category: {
      type: Object,
      required: true
    },
    isSuperAdmin: {
      type: Boolean,
      default: false
    },
    tenants: {
      type: Array,
      default: () => []
    },
    defaultTenantId: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      internalCategory: { ...this.category },
      durationHours: 24,
      categoryTypes: Object.values(ReportCategoryType),
      categoryLevels: Object.values(ReportCategoryLevel),
      rules: {
        title: [
          { required: true, message: this.$t('report_categories.name_required'), trigger: 'blur' }
        ],
        type: [
          { required: true, message: this.$t('report_categories.type_required'), trigger: 'change' }
        ],
        level: [
          { required: true, message: this.$t('report_categories.level_required'), trigger: 'change' }
        ],
        tenantId: [
          { required: true, message: this.$t('report_categories.tenant_required'), trigger: 'change' }
        ]
      }
    };
  },
  watch: {
    category: {
      immediate: true,
      handler(newVal) {
        this.internalCategory = { ...newVal };
        this.calculateDurationHours();
      }
    },
    defaultTenantId: {
      immediate: true,
      handler(newVal) {
        if (newVal && !this.internalCategory.tenantId) {
          this.internalCategory.tenantId = newVal;
        }
      }
    }
  },
  methods: {
    calculateDurationHours() {
      this.durationHours = Math.floor(this.internalCategory.visibilityDurationInMillis / (1000 * 60 * 60));
    },
    updateDurationMillis(hours) {
      this.internalCategory.visibilityDurationInMillis = hours * 60 * 60 * 1000;
    },
    updateColorCSS(color) {
      this.internalCategory.colorCSS = `color: ${color};`;
    },
    submitForm() {
      this.$refs.categoryForm.validate((valid) => {
        if (valid) {
          this.$emit('submit', this.internalCategory);
        }
      });
    }
  }
};
</script>

<style scoped>
.el-select {
  width: 100%;
}
</style>
